<template>
  <div class="list-group-item animate__animated">
    <a v-bind:href="url" :target="target">
      <div class="row">
        <div class="col-xs-12 col-sm-5 col-md-3 list-group-item-image">
          <div class="list-image">
            <responsive-concrete-image v-if="tripData.overrides && tripData.overrides.imagePath"
                                       :src="tripData.overrides.imagePath"
                                       :available-thumbnails='tripData.overrides.imagePaths'
                                       :aspect-ratio="16/9"
                                       img-class="travel-preview-picture img-responsive"/>
            <responsive-image v-else-if="tripData.bilder"
                              :src="tripData.bilder.jpg_fallback_16x9"
                              :src-xs="tripData.bilder.img800_16x9"
                              :src-sm="tripData.bilder.img400_16x9"
                              :src-md="tripData.bilder.img400_16x9"
                              :src-lg="tripData.bilder.img400_16x9"
                              img-class="travel-preview-picture img-responsive"/>
            <div class="list-image-overlays" v-if="!tripData.overrides || !tripData.overrides.hideLabels">
              <i v-if="tripData.overrides && tripData.overrides.icon && tripData.overrides.icon != '.no icon'" :class="'icon ' + tripData.overrides.icon + ' circle icon-overlay-right'"></i>
              <i v-else-if="tripData.icon && tripData.icon != '.no icon'" :class="'icon ' + tripData.icon + ' circle icon-overlay-right'"></i>
              <div class="label-guaranteed" v-if="isGuaranteed">
                Alle Abreisen garantiert
              </div>
              <div class="label-soldout" v-if="isFullyBooked">
                Ausgebucht
              </div>
              <div class="label-koenigsklasse" v-if="isKoenigsklasse"></div>
              <div class="label-komfortklasse" v-if="isKomfortklasse"></div>
              <div v-if="tripData.code" class="travel-remember"
                   :class="{selected: isRemembered}"
                   :data-code="tripData.code"
                   v-on:click.prevent="toggleRemember()"
                   :title="(isRemembered)?'Von Merkliste entfernen':'Auf Merkliste setzen'">
                <i class="icon very-small icon-pin"></i>
                <span class="text">Reise gemerkt</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-7 col-md-5 list-group-item-content">
          <div v-if="tripData.overrides && tripData.overrides.content">
            <requirement-rating v-if="tripData.schwierigkeitsgrad" title="Anforderungsprofil"
                                :rating="tripData.schwierigkeitsgrad"/>
            <div v-html="tripData.overrides.content"></div>
          </div>
          <div v-else>
            <p v-if="tripData.schiff_rmt" class="ship-name">{{ tripData.schiff_rmt }}</p>
            <h4>{{ tripData.tdbez }}</h4>
            <p class="termine">{{ tripData.abreisedatentext }}</p>
            <requirement-rating v-if="typeof tripData.schwierigkeitsgrad === 'number'" title="Anforderungsprofil" :rating="tripData.schwierigkeitsgrad"/>
            <p class="description">{{ tripData.beschreibung }}</p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-7 col-md-4 list-group-item-button pull-right">
          <span class="btn btn-primary btn-arrow" v-html="button"></span>
        </div>
      </div>
    </a>
  </div>
</template>
<style></style>
<script type="module">
import ResponsiveImage from './_responsive-image.vue';
import AnalyticsMixin from '../mixins/analytics-mixin.js';
import RememberMixin from "../mixins/remember-mixin";
import TravelOverrideMixin from "../mixins/travel-override-mixin";

export default {
  name: "travel-list-item",
  props: {
    tripData: {
      type: [ Object, Boolean ],
      default: false
    }
  },
  mixins: [AnalyticsMixin, RememberMixin, TravelOverrideMixin],
  data: function () {
    return {
      isRemembered: false
    }
  },
  computed: {

  },
  methods: {

  },
  mounted(){

  },
  created() {

  },
  updated() {

  }
}
</script>
